import { useParams } from "react-router-dom"
import { useGetWeatherStationDevicesQuery } from "../../../api/rtk/weatherStations/slices/weatherStationsApiSlice"
import { useDispatch } from "react-redux";
import { setDeviceId } from "../../../stateManagement/reducers/services/weatherStations/WeatherStationsSlice";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { useEffect } from "react";

export function DeviceList() {
    const dispatch = useDispatch();
    const { stationId } = useParams();
    const token = useAppSelector(state => state.auth.tokens.services?.weatherStations);
    const deviceId = useAppSelector(state => state.weatherStationsService.deviceId)
    const { data: devices } = useGetWeatherStationDevicesQuery({ stationId }, { skip: !token })

    useEffect(() => {
        if (Array.isArray(devices) && devices.length > 0) {
            dispatch(setDeviceId(devices[0]?.id))
        }
        return () => {
            dispatch(setDeviceId(undefined))
        }
    }, [devices])

    return (
        <div className="device-list-div">
            <span>Тип датчика:</span>
            {devices?.map(({ id, typeName }) => {
                return (
                    <div className={"device-item-div" + (deviceId === id ? ' active' : '')} onClick={() => dispatch(setDeviceId(id))}>
                        {typeName}
                    </div>
                )
            })}
        </div>
    )
}
